import React from "react";
import { Card } from "react-bootstrap";
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import Highcharts3D from 'highcharts/highcharts-3d';
import { RoomReportDataV4 } from "../../../../services/cm-group-report/response/RoomReportResponseV4";

// Inisialisasi modul 3D untuk Highcharts
Highcharts3D(Highcharts);

interface GroupRoomHighchartsV4Props {
    title: string;
    data: RoomReportDataV4[];
    dataKey: 'room_nights' | 'revenue';
    valueFormatter?: (value: number) => string;
}

const GroupRoomHighchartsV4: React.FC<GroupRoomHighchartsV4Props> = ({ title, data, dataKey, valueFormatter }) => {

    const chartData = data.map(item => ({
        name: item.property,
        y: Number(item[dataKey]),
    }));

    const getOptions = (): Highcharts.Options => ({
        chart: {
            type: 'pie',
            backgroundColor: 'transparent',
            options3d: {
                enabled: true,
                alpha: 45,
                beta: 0,
                depth: 50,
                viewDistance: 25
            }
        },
        title: {
            text: title,
            align: 'center',
            style: {
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        tooltip: {
            formatter: function () {
                const point = this.point as any;
                const value = point.y;
                const percentage = this.percentage;

                const formattedValue = valueFormatter ? valueFormatter(value) : value;

                return `<b>${point.name}</b>: ${formattedValue} (${percentage.toFixed(1)}%)`;
            }
        },
        // Legend dinonaktifkan
        legend: {
            enabled: false
        },
        plotOptions: {
            pie: {
                innerSize: '60%',
                depth: 45,
                allowPointSelect: true,
                cursor: 'pointer',
                // Konfigurasi label diubah agar sama seperti komponen agent
                dataLabels: {
                    enabled: true,
                    format: '<b>{point.name}</b>'
                },
                showInLegend: false
            }
        },
        series: [{
            type: 'pie',
            name: title,
            data: chartData
        }],
        credits: {
            enabled: false
        }
    });

    return (
        <Card className="h-100 shadow">
            <Card.Body>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={getOptions()}
                    containerProps={{ style: { height: '350px', width: '100%' } }}
                />
            </Card.Body>
        </Card>
    );
};

export default GroupRoomHighchartsV4;